import { useEffect } from "react";
import { MapRef, useMap } from "react-map-gl";
import { toast } from "react-toastify";
import { useMapStore } from "..";

export default function useDefaultMapLayer(visible: boolean, layerIdsProvider: (map: MapRef) => string[], isStyleLoadedOverride?: boolean) {
    const map = useMap().current!;
    const mapStore = useMapStore();

    useEffect(() => {
        if (isStyleLoadedOverride ?? mapStore.isStyleLoaded) {
            const layerIds = layerIdsProvider(map);
            const allLayerIds = map.getMap().getStyle()!.layers.map(layer => layer.id);
            if (!layerIds.every(id => allLayerIds.includes(id)))
                toast.error("The current map style doesn't include all required layers");
            else
                layerIds.forEach(id => map.getMap().setLayoutProperty(id, "visibility", visible ? "visible" : "none"));
        }
    }, [mapStore.isStyleLoaded, isStyleLoadedOverride, visible]);
}